import './style.css'

interface TEXT_INPUT_TYPE {
  name: string
  value: string
  placeholder: string
  icon: string
  type: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const LoginField: React.VFC<TEXT_INPUT_TYPE> = ({
  value,
  placeholder,
  onChange,
  icon,
  type
}) => {
  return (
    <div className="group-text-input">
      <img className="icon" src={icon} alt="text-input-icon" />
      <input
        autoComplete="off"
        className="text-input"
        type={type}
        name="id"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
    </div>
  )
}
